'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require('./components/Icon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/~/@ant-design/icons-react/lib/index.js
// module id = 700
// module chunks = 0